import { type FC } from 'react'

import { useFilteredOrderedReferences } from 'hooks/useFilteredOrderedReferences'
import { useStreamingReferences } from 'stores/useStreamingReferencesStore'
import { Message } from 'types/Api'

import { isMessageProcessing } from 'utils/isMessageProcessing'

import { ReferencesPanelBody } from './components/ReferencesPanelBody'
import { ReferencesPanelHeader } from './components/ReferencesPanelHeader'

type Props = {
  aiMessage: Message
  onClose?: VoidFunction
}

export const ReferencesPanel: FC<Props> = ({ aiMessage, onClose }) => {
  const streamingReferences = useStreamingReferences(aiMessage.id)

  const isProcessing = isMessageProcessing(aiMessage)

  const references = isProcessing ? streamingReferences : aiMessage.references

  const filteredOrderedReferences = useFilteredOrderedReferences(aiMessage.id, references)

  return (
    <div
      className="flex flex-col text-default-on-bg-karnovnote print:mt-6"
      translate={isProcessing ? 'no' : 'yes'}
    >
      <ReferencesPanelHeader
        messageId={aiMessage.id}
        onClose={onClose}
        referenceCount={filteredOrderedReferences.length}
        showReferencesCount={aiMessage.status === 'success'}
      />
      <ReferencesPanelBody
        isCanceled={aiMessage.canceled}
        isProcessing={isProcessing}
        messageId={aiMessage.id}
        messageStatus={aiMessage.status}
        references={filteredOrderedReferences}
      />
    </div>

  )
}
